export const TOGGLE_MODAL = "TOGGLE_MODAL";

export const toggleModal = modal => {
  return {
    type: TOGGLE_MODAL,
    payload: modal,
  };
};
